import Vue from 'vue'
import VueRouter from 'vue-router'
// Routes
import dashboard from '@/0-dashboard/routes'
import shiftsAndGigs from '@/1-shifts-&-gigs/routes'
import hr from '@/2-hr/routes'
import payAndBilling from '@/3-pay-&-billing/routes'
import pages from '@/pages/routes'
import hwUi from '@hw-ui/routes'
import { canNavigate } from '@hw-core/libs/acl/routeProtection'
import { getHomeRouteForLoggedInUser } from '@hw-core/auth/utils'
import store from '@/shared/store/'
import storeModules from '@/shared/store/apps'

Vue.use(VueRouter)

const hwUiRoutes = hwUi.map(route => ({
  ...route, 
  path: `/hw-ui${route.path}`,
  meta: {
    ...route.meta,
  }
}))

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'apps-gigs-management-list' } },
    ...dashboard,
    ...hr,
    ...payAndBilling,
    ...shiftsAndGigs,
    ...pages,

    ...hwUiRoutes,
    { // Make sure it's your last route definition
      path: '*',
      redirect: 'error-404',
    },
  ],
})


router.beforeEach((to, _, next) => {
  const isLoggedIn = store.getters['appAuth/isLoggedIn']
  if (to.name !== 'services-tuberculosis-survey' && !canNavigate(to)) {   // TODO does not work as expected
    return next({ name: isLoggedIn ? 'misc-not-authorized' : 'auth-login'}) // if logged in redirect to unauthorized, otherwise login page
  }
  if (isLoggedIn && to.meta.redirectIfLoggedIn) {
    const {authUser} = store.state.appAuth
    next(getHomeRouteForLoggedInUser(authUser ? authUser.role : null))
  }

  // dynamically register module
  const {namespace, module} = storeModules[to.name] || {}
  if (namespace && module && !store.hasModule(namespace)){
    store.registerModule(namespace, module)
  }

  return next()
})

export default router
